<template>
  <div id="profile-user">
    
    <v-card
      flat
    >
      <v-img
        :src="img"
        max-height="200"
        aspect-ratio=1.5
        position="center left"
        gradient="to right, rgba(0,0,0,.44), rgba(0,0,0,.44)"
      >
        <v-container fill-height>
          <v-layout align-center>
            <v-avatar
              size="100"
              class="display-2 font-weight-regular mr-2"
              color="primary"
            >
              <img src="@/assets/Ammonyte_Logo-23.png" alt="avatar">
            </v-avatar>
            <v-layout column justify-end>
              <div class="headline font-weight-light">{{userName}}</div>
              <div class="text-uppercase font-weight-light">{{userEmail}}</div>
            </v-layout>
          </v-layout>
        </v-container>
      </v-img>
    </v-card>
    

    
      <v-container fluid>
        <v-flex xs12 sm10 offset-sm1>
          <v-card color="grey darken-4">
            <v-card-text>
              <p><b>Status:</b> <span id="status" :style="cssProps">Online</span></p>
              <p><b>email:</b> {{userEmail}}</p>
              <p><b>Availability:</b> Your schedule here.</p>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-container>
    

    

  </div>
</template>

<script>
export default {
  data () {
    return {
      img: `https://images.unsplash.com/photo-1459128806329-1b61d19a0f93?ixlib=rb-0.3.5&s=da175f2d8028af8c0e77f46335b10042&auto=format&fit=crop&w=1350&q=80`,
      avatar: '../../assets/AmmonyteLogo-21.png'
    }
  },

  computed: {
    userName() {
      return this.getUsername()
    },
    userEmail: function () {
      return this.getEmail()
    },
    cssProps: function () {
      // Use this method (combined with scoped styles) to apply theme colors to HTML element attributes
      return {'--accent-color': this.$vuetify.theme.accent}
    }
  },

  methods: {
    updateName() {
      (this.userName !== '') ? this.$store.dispatch('updateUserName', {name: this.username}) : console.log("Don't do that, hunny....")
    },
    getUsername() {
      var uname = this.$store.getters.username
      return (uname !== null && uname !== undefined) ? uname : this.getEmail().split('@')[0]
    },
    getEmail: function () {
      var email = this.$store.getters.email
      return (email !== null && email !== undefined) ? email : 'username@email.com'
    }
  }
}
</script>

<style scoped>
#status {
  /* color: var(--accent-color); */
  color: #00ff00;
}

p {
  font-size: 18px;
}
</style>




// WEBPACK FOOTER //
// src/layouts/profile/Profile.vue